<template>
  <div class="menu-btn-edit">
    <el-form class="zwx-form edit-form" key="mainForm" ref="mainForm" :model="mainForm"
             :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <base-headline title="基本信息" class="headline no-top" />
      <div>
        <div class="edit-row">
          <el-form-item label-width="82px" label="按钮名称：" prop="btnName">
            <el-input class="zwx-input" v-model="mainForm.btnName" maxlength="50" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label-width="82px" label="状态：" required>
            <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
              <el-radio class="zwx-radio" :label="true">启用</el-radio>
              <el-radio class="zwx-radio" :label="false">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <fixed-footer>
      <el-button class="zwx-button zwx-button-32" type="primary"
                 @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交
      </el-button>
      <el-button class="zwx-button zwx-button-32" @click="back()">返回</el-button>
    </fixed-footer>
  </div>
</template>

<script>
export default {
  name: "MenuBtnEdit",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      menuId: this.$route.params.menuId,
      mainForm: {
        btnName: "",
        ifEnable: true
      },
      rules: {
        btnName: [{ required: true, message: "请输入按钮名称", trigger: ["change", "blur"] }]
      }
    };
  },
  created() {
  },
  mounted() {
    this.detail();
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  methods: {
    detail() {
      if (this.rid === undefined) return;
      this.$emit("loading", true);
      let data = {
        rid: this.rid
      };
      this.$system.get(this.api + "/systematic/getBtn-1", data, true, true, this.detailSuccess, this.detailError);
    },
    detailSuccess(data) {
      if (data.type === "00") {
        this.mainForm.btnName = data.btn.btnName;
        this.mainForm.ifEnable = data.btn.ifEnable;
        this.$emit("loading", false);
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
        this.back();
      }
    },
    detailError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
      this.back();
    },
    commit() {
      this.$emit("loading", true);
      let data = {
        rid: this.rid,
        fkByMenuId: {
          rid: this.menuId
        },
        btnName: this.mainForm.btnName,
        ifEnable: this.mainForm.ifEnable
      };
      this.$system.postJson(this.api + "/systematic/addOrModifyBtn-1", data, true, true, this.commitSuccess, this.commitError);
    },
    commitSuccess(data) {
      if (data.type === "00") {
        this.$system.notify("成功", data.mess, "success");
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } });
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    commitError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name });
    }
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
